module.exports = "/images/ny-blck-12.jpg";